import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaitoashtavinayakcab() {



    const cardData = {

keyword: "Navi Mumbai to Ashtavinayak Cab Service",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Navi Mumbai to Ashtavinayak Cab Service for pilgrimage tours, family trips, group travel, and one-day or multi-day Ashtavinayak Darshan journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup across Navi Mumbai, and comfortable travel throughout Maharashtra, we ensure a smooth, spiritual, and hassle-free Ashtavinayak Yatra experience for all devotees.",

topPlaces: [
    {
        title: "Moreshwar Ganpati Temple - Morgaon",
        description:
            "Moreshwar Temple at Morgaon is considered the starting and ending point of the sacred Ashtavinayak Yatra and is one of the most important Ganpati temples in Maharashtra."
    },
    {
        title: "Siddhivinayak Temple - Siddhatek",
        description:
            "Siddhatek is home to Lord Siddhivinayak and is believed to grant success and fulfillment of wishes to devotees visiting the temple."
    },
    {
        title: "Ballaleshwar Temple - Pali",
        description:
            "Ballaleshwar Temple in Pali is the only Ashtavinayak temple named after a devotee and holds great spiritual significance among Ganesh devotees."
    },
    {
        title: "Varadvinayak Temple - Mahad",
        description:
            "Varadvinayak Temple is known as the temple of wish fulfillment where devotees seek blessings for prosperity, happiness, and success."
    },
    {
        title: "Chintamani Temple - Theur",
        description:
            "Chintamani Temple in Theur is associated with removing worries and bringing peace of mind, making it a highly revered Ganesh shrine."
    },
    {
        title: "Girijatmaj Temple - Lenyadri",
        description:
            "Girijatmaj Temple is uniquely located inside a mountain cave and is believed to be the place where Goddess Parvati worshipped Lord Ganesha."
    },
    {
        title: "Vighnahar Temple - Ozar",
        description:
            "Vighnahar Temple at Ozar is dedicated to the remover of obstacles and is known for its beautiful architecture and spiritual atmosphere."
    },
    {
        title: "Mahaganpati Temple - Ranjangaon",
        description:
            "Mahaganpati Temple is one of the most powerful Ganesh temples in Maharashtra and is visited by devotees seeking divine blessings and protection."
    },
    {
        title: "Jejuri Khandoba Temple",
        description:
            "Jejuri, located near several Ashtavinayak temples, is famous for the Khandoba Temple and its vibrant turmeric-filled religious celebrations."
    },
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar Jyotirlinga is a revered Shiva temple often included with Ashtavinayak tours, offering a complete spiritual pilgrimage experience."
    }
],



services: [
{
name: "Navi Mumbai to Ashtavinayak Cab",
description: "Navi Mumbai to Ashtavinayak Cab service by 1Touch Cabs offers safe, comfortable, and reliable pilgrimage transportation for devotees visiting the Ashtavinayak Ganpati temples. We provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and Tempo Traveller with professional chauffeurs experienced in long-distance temple tours. Whether it is a one-day darshan, round trip, or customized yatra plan, we ensure punctual pickups, smooth highway travel, luggage assistance, and a stress-free spiritual journey. With 24x7 availability, transparent pricing, and easy booking options, we make Ashtavinayak travel from Navi Mumbai convenient, safe, and peaceful."
},
{
name: "Navi Mumbai Ashtavinayak Darshan Cab",
description: "Navi Mumbai Ashtavinayak Darshan Cab service is designed for devotees planning a comfortable and well-organized pilgrimage to all eight Ashtavinayak temples. 1Touch Cabs provides experienced drivers familiar with temple routes, clean air-conditioned vehicles, and flexible travel schedules. We ensure smooth coordination, safe driving, and timely darshan visits so that passengers can focus on their spiritual journey without travel stress."
},
{
name: "Ashtavinayak Cab Service from Navi Mumbai",
description: "Ashtavinayak Cab Service from Navi Mumbai offers complete travel solutions for Ganpati devotees, families, and group pilgrims. 1Touch Cabs ensures reliable transportation with professional chauffeurs, well-maintained vehicles, and comfortable seating for long journeys. Our service focuses on safety, punctuality, and a peaceful travel experience throughout the Ashtavinayak route."
},
{
name: "Navi Mumbai to Ashtavinayak Taxi",
description: "Navi Mumbai to Ashtavinayak Taxi service provides convenient and affordable pilgrimage travel with experienced drivers and clean vehicles. 1Touch Cabs ensures smooth highway rides, flexible stop options for darshan, and comfortable seating for families and groups. We make spiritual travel easy, safe, and well-organized."
},
{
name: "Ashtavinayak Yatra Cab from Navi Mumbai",
description: "Ashtavinayak Yatra Cab from Navi Mumbai service offers a complete pilgrimage package covering all major Ganpati temples in Maharashtra. 1Touch Cabs provides spacious vehicles, knowledgeable chauffeurs, and flexible itineraries for a comfortable yatra experience. Ideal for families, senior citizens, and devotional groups."
},
{
name: "Navi Mumbai to Ashtavinayak Taxi Service",
description: "Navi Mumbai to Ashtavinayak Taxi Service ensures reliable and punctual transportation for devotees traveling to Ashtavinayak temples. 1Touch Cabs provides professional drivers, clean vehicles, and smooth travel coordination for a stress-free pilgrimage experience."
},
{
name: "Ashtavinayak Taxi Booking Navi Mumbai",
description: "Ashtavinayak Taxi Booking Navi Mumbai service allows easy and quick reservation of pilgrimage cabs with instant confirmation. 1Touch Cabs offers flexible booking options, transparent pricing, and multiple vehicle choices for a comfortable temple tour experience."
},
{
name: "AC Cab for Ashtavinayak from Navi Mumbai",
description: "AC Cab for Ashtavinayak from Navi Mumbai service provides fully air-conditioned comfortable travel for long pilgrimage routes. 1Touch Cabs ensures clean interiors, professional chauffeurs, and smooth highway driving for a relaxing spiritual journey."
},
{
name: "Round Trip Cab Navi Mumbai to Ashtavinayak",
description: "Round Trip Cab Navi Mumbai to Ashtavinayak service offers complete return travel solutions for devotees visiting all Ashtavinayak temples. 1Touch Cabs provides flexible scheduling, waiting options, and comfortable vehicles for a hassle-free round trip experience."
},
{
name: "One Day Ashtavinayak Cab from Navi Mumbai",
description: "One Day Ashtavinayak Cab from Navi Mumbai service is ideal for devotees planning a quick and well-organized same-day temple darshan. 1Touch Cabs ensures early pickup, optimized route planning, and experienced drivers for timely completion of the pilgrimage."
},
{
name: "Ashtavinayak Darshan Cab Booking",
description: "Ashtavinayak Darshan Cab Booking service provides easy online reservation for all types of pilgrimage vehicles. 1Touch Cabs offers instant confirmation, professional chauffeurs, and flexible travel plans for a smooth spiritual journey."
},
{
name: "Ganpati Darshan Cab from Navi Mumbai",
description: "Ganpati Darshan Cab from Navi Mumbai service offers dedicated transportation for visiting Ganpati temples across Maharashtra. 1Touch Cabs ensures safe travel, comfortable seating, and experienced drivers for a peaceful devotional experience."
},
{
name: "Ashtavinayak Yatra Taxi Service",
description: "Ashtavinayak Yatra Taxi Service provides reliable and comfortable transportation for complete Ashtavinayak temple tours. 1Touch Cabs ensures professional service, clean vehicles, and smooth travel coordination for all devotees."
},
{
name: "Ashtavinayak Ganpati Tour Cab",
description: "Ashtavinayak Ganpati Tour Cab service offers well-planned pilgrimage travel covering all eight Ganpati temples. 1Touch Cabs provides experienced chauffeurs, comfortable vehicles, and flexible itineraries for a meaningful spiritual journey."
},
{
name: "Ashtavinayak Darshan One Day Cab",
description: "Ashtavinayak Darshan One Day Cab service is perfect for devotees who want to complete the pilgrimage in a single day. 1Touch Cabs ensures early start, efficient routing, and safe driving for timely darshan completion."
},
{
name: "Innova Cab Navi Mumbai to Ashtavinayak",
description: "Innova Cab Navi Mumbai to Ashtavinayak service provides spacious and comfortable travel for families and groups. 1Touch Cabs offers well-maintained Innova vehicles with experienced chauffeurs for a smooth and safe pilgrimage journey."
},
{
name: "Ertiga Cab for Ashtavinayak Darshan",
description: "Ertiga Cab for Ashtavinayak Darshan service offers budget-friendly and comfortable 6–7 seater travel for small families and groups. 1Touch Cabs ensures reliable service, professional drivers, and smooth pilgrimage transportation."
}
],

tableData: [
["Navi Mumbai to Ashtavinayak Cab","Navi Mumbai Ashtavinayak Darshan Cab"],
["Ashtavinayak Cab Service from Navi Mumbai","Navi Mumbai to Ashtavinayak Taxi"],
["Ashtavinayak Yatra Cab from Navi Mumbai","Navi Mumbai to Ashtavinayak Taxi Service"],
["Ashtavinayak Taxi Booking Navi Mumbai","AC Cab for Ashtavinayak from Navi Mumbai"],
["Round Trip Cab Navi Mumbai to Ashtavinayak","One Day Ashtavinayak Cab from Navi Mumbai"],
["Ashtavinayak Darshan Cab Booking","Ganpati Darshan Cab from Navi Mumbai"],
["Ashtavinayak Yatra Taxi Service","Ashtavinayak Ganpati Tour Cab"],
["Ashtavinayak Darshan One Day Cab","Innova Cab Navi Mumbai to Ashtavinayak"],
["Ertiga Cab for Ashtavinayak Darshan","Navi Mumbai to Ashtavinayak Cab Service"]
],












whychoose: [
    {
        WhyChooseheading: "Reliable Navi Mumbai to Ashtavinayak Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Navi Mumbai to Ashtavinayak Cab Services for devotees, families, senior citizens, pilgrimage groups, and spiritual travelers seeking comfortable transportation."
    },
    {
        WhyChooseheading: "Complete Ashtavinayak Darshan Tour",
        WhyChoosedescription: "Travel conveniently to all eight sacred Ganpati temples of Maharashtra with our customized Ashtavinayak Darshan cab packages designed for a peaceful pilgrimage experience."
    },
    {
        WhyChooseheading: "Perfect for Religious and Family Tours",
        WhyChoosedescription: "Our cab services are ideal for family pilgrimages, group tours, temple visits, spiritual journeys, and special Ganesh devotion trips throughout the year."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "Customized One-Day and Multi-Day Packages",
        WhyChoosedescription: "Whether you prefer a one-day express darshan, two-day pilgrimage, or customized temple tour package, we provide flexible travel solutions."
    },
    {
        WhyChooseheading: "Pickup Available Across Navi Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Vashi, Nerul, Belapur, Kharghar, Panvel, Airoli, Ghansoli, Koparkhairane, CBD Belapur, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Pilgrimage Routes",
        WhyChoosedescription: "Our professional chauffeurs are familiar with all Ashtavinayak temple routes and ensure safe, comfortable, and hassle-free travel."
    },
    {
        WhyChooseheading: "Ideal for Families, Senior Citizens, and Groups",
        WhyChoosedescription: "From individual devotees and families to large pilgrimage groups and temple tour organizers, we provide suitable vehicles for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "What is included in the Navi Mumbai to Ashtavinayak Cab Service?",
        answer: "The package covers visits to all eight Ashtavinayak Ganpati temples with comfortable transportation and customizable travel plans."
    },
    {
        question: "Can I book a one-day Ashtavinayak Darshan trip?",
        answer: "Yes, one-day, two-day, and customized multi-day Ashtavinayak tour packages are available."
    },
    {
        question: "Which vehicle is suitable for Ashtavinayak Darshan?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to group size."
    },
    {
        question: "Which temples are covered in the Ashtavinayak Yatra?",
        answer: "The tour covers Morgaon, Siddhatek, Pali, Mahad, Theur, Lenyadri, Ozar, and Ranjangaon Ganpati temples."
    },
    {
        question: "Can senior citizens comfortably travel on this route?",
        answer: "Yes, we provide spacious and comfortable vehicles suitable for senior citizens, families, and long-distance pilgrimage travel."
    },
    {
        question: "Are Tempo Travellers available for group pilgrimages?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for religious groups, family tours, and temple pilgrimage trips."
    },
    {
        question: "Can I start the journey from any Navi Mumbai location?",
        answer: "Yes, pickup services are available from homes, hotels, offices, railway stations, and all major areas of Navi Mumbai."
    },
    {
        question: "Do you provide customized temple tour itineraries?",
        answer: "Yes, customers can customize their Ashtavinayak itinerary according to travel duration, darshan preferences, and group requirements."
    },
    {
        question: "Is advance booking recommended for Ashtavinayak Darshan?",
        answer: "Yes, advance booking is recommended, especially during weekends, Ganesh festivals, Sankashti Chaturthi, and holiday seasons."
    },
    {
        question: "How can I book a Navi Mumbai to Ashtavinayak Cab Service?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Vinod Patankar",
        feedback:
            "Our Ashtavinayak Darshan trip was beautifully organized. The driver was knowledgeable about all temple routes, and the vehicle was extremely comfortable throughout the pilgrimage.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Shubhangi Kulkarni",
        feedback:
            "We traveled with senior family members for Ashtavinayak Darshan and had an excellent experience. The cab was spacious, clean, and the entire journey was smooth and stress-free.",
        rating: 5
    }
];
























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Ashtavinayak Cab Service",
  "image": "https://www.mumbaiairportcabs.com/assets/images/navi-mumbai-to-ashtavinayak-cab.jpg",
  "description": "Book Navi Mumbai to Ashtavinayak cab service for a comfortable and spiritual pilgrimage journey. Mumbai Airport Cabs offers safe, reliable, and AC taxi service for Ashtavinayak darshan with experienced drivers and 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5320"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹9,999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/navi-mumbai-to-ashtavinayak-cab-service"
  }
};








    return (
        <div>



<Helmet>
  <title>Navi Mumbai to Ashtavinayak Cab Service | Darshan Taxi Booking | +91 9545731161</title>

  <meta
    name="description"
    content="Book Navi Mumbai to Ashtavinayak cab service for comfortable pilgrimage travel. AC taxi with professional drivers for Ashtavinayak darshan and round trip packages."
  />

  <meta
    name="keywords"
    content="Navi Mumbai to Ashtavinayak Cab, Navi Mumbai Ashtavinayak Darshan Cab, Ashtavinayak Cab Service from Navi Mumbai, Navi Mumbai to Ashtavinayak Taxi, Ashtavinayak Yatra Cab from Navi Mumbai, Navi Mumbai to Ashtavinayak Taxi Service, Ashtavinayak Taxi Booking Navi Mumbai, AC Cab for Ashtavinayak from Navi Mumbai, Round Trip Cab Navi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Navimumbaitoashtavinayakcab;